module.exports = __webpack_public_path__ + "static/gallery_02-thumb-8b49fa58189b5a060960e32f4d0066e9.jpg";